module.exports = __webpack_public_path__ + "img/img_i_coun_03.abd6a059.png";